import { render, staticRenderFns } from "./KursVorlageModal.vue?vue&type=template&id=178e80ee&"
import script from "./KursVorlageModal.vue?vue&type=script&lang=js&"
export * from "./KursVorlageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports